/* eslint-disable no-empty */
import { takeLatest, all, call, put } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import * as addonActions from './actions';
import * as Constants from './constants';

import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import { getSession, setSession, GetProcessStepPages, GetCurrentPageName, enablePegaProcessSteps } from '../../components/common/Helpers';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';

const flowType = getSession('FlowType');
const errorLog = {
  json: true,
  eventType: 'BLOCKER',
  message: 'GENERIC_ERROR_PAGE',
  note: 'from addon component',
};
function* getAddons() {
  showLoader();
  yield put(notificationActions.hideNotification());
  let errorDetails = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  try {
    const apiResponse = yield call(addonActions.getAddonsAPI);
    if (apiResponse && apiResponse.data && apiResponse.data.statusCode === '200' && !apiResponse.data.errors) {
      yield put({ type: Constants.ADDONS_RESPONSE_RECEIVED, response: apiResponse.data.addOns });
      yield put({ type: 'API_LOADED', response: true });
      yield put({ type: 'ADDONS_API_SUCCESS', response: true });
      if (flowType === 'LTE' && isEmpty(apiResponse?.data?.addOns?.featureServices) && isEmpty(apiResponse?.data?.addOns?.landLineServices)) {
        logger(errorLog);
      }
      if (
        flowType === '5G' &&
        isEmpty(apiResponse?.data?.addOns?.featureServices) &&
        isEmpty(apiResponse?.data?.addOns?.streamingServices) &&
        isEmpty(apiResponse?.data?.addOns?.accessoryDetails) &&
        isEmpty(apiResponse?.data?.addOns?.whwServices)
      ) {
        logger(errorLog);
      }
    } else {
      if (
        (apiResponse && apiResponse.data && apiResponse.data.errors) ||
        (apiResponse && apiResponse.request && apiResponse.request.status !== '200')
      ) {
        errorDetails = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getAddons ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
    }
  } catch (error) {
    if (error && error.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
  }
  hideLoader();
}

function* fetchE911Address() {
  let errorDetails = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(addonActions.fetchE911Address);
    if (apiResponse && apiResponse.data && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.FETCH_E911ADDRESS_SUCCESS, response: apiResponse.data });
      hideLoader();
    } else {
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        errorDetails = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `fetchE911Address ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
      // logError('fetchE911Address', apiResponse?.data?.errors, FE_API_ERROR);
    }
  } catch (error) {
    // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
    if (error && error.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      hideLoader();
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('fetchE911Address', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* visionPending(visionData) {
  yield put({ type: Constants.ASYNC_FETCH });
  let errorDetails = false;
  showLoader();
  try {
    const apiResponse = yield call(addonActions.visionPending, visionData);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data?.errors) {
      yield put({ type: 'WHW_VISION_PENDING_ORDER', value: true });
      hideLoader();
    } else {
      yield put({ type: 'WHW_VISION_PENDING_ORDER', value: false });
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails, errorMessage: 'Please try after some time' });
      hideLoader();
    }
  } catch (error) {
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getNPANXX(data) {
  // let errorDetails = false;
  // yield put({ type: Constants.ERORR_ADDON, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(addonActions.getNPANXXAPI, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      // yield put({ type: Constants.ASSIGN_MTN_STATUS, response: true });
      yield put({ type: Constants.GET_NPA_NXX_SUCCESS, response: apiResponse.data });
      if (apiResponse.data.data && apiResponse.data.data.npanxxlist && apiResponse.data.data.npanxxlist[0]) {
        const npanxx = apiResponse.data.data.npanxxlist[0].npa + apiResponse.data.data.npanxxlist[0].nxx;
        const { ngp1 } = apiResponse.data.data.npanxxlist[0];
        setSession('5g_line', npanxx);
        const assignMtnapiResponse = yield call(addonActions.assignNPANXXMTN, npanxx, ngp1);
        if (assignMtnapiResponse) {
          yield put({ type: Constants.ASSIGN_MTN_STATUS, response: true });
        }
      } else {
        yield put({ type: Constants.ASSIGN_MTN_STATUS, response: true });
      }
      hideLoader();
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getNPANXX ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
      hideLoader();
    }
  } catch (error) {
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* addYTTVtoCart(data) {
  let errorDetails = false;
  let invalidErrorCase = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponseAddYTTV = yield call(addonActions.addYTTVtoCartAPI, data);
    if (apiResponseAddYTTV && apiResponseAddYTTV.data && apiResponseAddYTTV.status === '00' && !apiResponseAddYTTV.data.errors) {
      yield put({ type: Constants.ADDONS_RESPONSE_RECEIVED, response: apiResponseAddYTTV.data.output });
      // yield put(hideLoader());
    } else {
      if (apiResponseAddYTTV && apiResponseAddYTTV.data && apiResponseAddYTTV.data.errors) {
        if (apiResponseAddYTTV?.status === 400 && checkInvalidCaseCartError(apiResponseAddYTTV.data.errors)) {
          invalidErrorCase = true;
          yield put({
            type: Constants.CEF_ADDONS_API_ERROR,
            errorDetails: invalidErrorCase,
            errorMessage: apiResponseAddYTTV?.data?.errors[0]?.notifyMessage,
          });
        } else {
          errorDetails = true;
          yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponseAddYTTV?.data?.errors[0]?.notifyMessage });
        }
        if (apiResponseAddYTTV.data.loggerData)
          apiResponseAddYTTV.data.loggerData.note = `addYTTVtoCart ${apiResponseAddYTTV?.data?.loggerData.note}`;
        logger(apiResponseAddYTTV?.data?.loggerData);
        hideLoader();
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
      // logError('addYTTVtoCart', apiResponse?.data?.errors, FE_API_ERROR);
    }
  } catch (errorAddYTTV) {
    if (errorAddYTTV && errorAddYTTV.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      hideLoader();
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
    // logError('addYTTVtoCart', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getPromos() {
  let errorDetails = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(addonActions.getPromosFromAEM);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.PROMOS_RESPONSE_RECEIVED, response: apiResponse.data });
      // yield put(hideLoader());
    } else {
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        errorDetails = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `from getAddons ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
      // yield put(hideLoader());
      // logError('getNPANXX', apiResponse?.data?.errors, FE_API_ERROR);
    }
  } catch (error) {
    if (error && error.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getNpanxxCall(data) {
  let errorDetails = false;
  yield put({ type: Constants.ERORR_ADDON, errorDetails });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  showLoader();
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(addonActions.getNPANXXAPI, data);
    if (apiResponse && apiResponse.data && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_NPA_NXX_SUCCESS, response: apiResponse.data });
      hideLoader();
    } else {
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        errorDetails = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getNpanxxCall ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      yield put({ type: Constants.ERORR_ADDON, errorDetails });
      yield put({ type: Constants.GET_NPA_NXX_FAILURE, response: apiResponse.data });
      yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      hideLoader();
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = true;
      yield put({ type: Constants.ERORR_ADDON, errorDetails });
      yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* callAssignMtnApi(data) {
  let errorDetails = false;
  let invalidErrorCase = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  showLoader();
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
    const apiResponseAssignNPANXX = yield call(addonActions.assignNPANXXMTN, data.data.npanxx, data.data.ngp1, data.data.nonGeoLine);
    if (apiResponseAssignNPANXX && apiResponseAssignNPANXX.data && apiResponseAssignNPANXX.status === 200 && !apiResponseAssignNPANXX.data.errors) {
      yield put({ type: Constants.ASSIGN_MTN_STATUS, response: true });
      hideLoader();
    } else {
      if (apiResponseAssignNPANXX && apiResponseAssignNPANXX.data && apiResponseAssignNPANXX.data.errors) {
        if (apiResponseAssignNPANXX?.status === 400 && checkInvalidCaseCartError(apiResponseAssignNPANXX.data.errors)) {
          invalidErrorCase = true;
          yield put({
            type: Constants.CEF_ADDONS_API_ERROR,
            errorDetails: invalidErrorCase,
            errorMessage: apiResponseAssignNPANXX?.data?.errors[0]?.notifyMessage,
          });
        } else {
          errorDetails = true;
          yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponseAssignNPANXX?.data?.errors[0]?.notifyMessage });
        }
        if (apiResponseAssignNPANXX.data.loggerData)
          apiResponseAssignNPANXX.data.loggerData.note = `callAssignMtnApi ${apiResponseAssignNPANXX?.data?.loggerData.note}`;
        logger(apiResponseAssignNPANXX?.data?.loggerData);
        hideLoader();
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
      // logError('callAssignMtnApi', apiResponse?.data?.errors, FE_API_ERROR);
      // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
    }
  } catch (errorAssignNPANXX) {
    if (errorAssignNPANXX && errorAssignNPANXX.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      hideLoader();
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('callAssignMtnApi', error, FE_API_JS_ERROR);
    // yield put({ type: Constants.PAGE_LOAD_API_ERROR });
  }
}

function* isNpaCall(value) {
  yield put({ type: Constants.IS_NPA_CALL, data: value.data });
}

function* homeLineCall(value) {
  yield put({ type: Constants.HOME_LINE, data: value.data });
}

function* updateMTNStatus(value) {
  yield put({ type: Constants.ASSIGN_MTN_STATUS, response: value.data });
}

function* isSkip(value) {
  yield put({ type: Constants.IS_NPA_CALL, data: value.data });
}

function* setAddons(data) {
  yield put({ type: Constants.ASSIGN_ADDONS, value: data });
}

function* validatee911Call(data) {
  let errorDetails = false;
  let invalidErrorCase = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  showLoader();
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponseValidateE911 = yield call(addonActions.callValidateE911, data);
    if (apiResponseValidateE911 && apiResponseValidateE911.data && !apiResponseValidateE911.data.errors) {
      yield put({ type: Constants.VALIDATE_E911_RESPONSE, response: apiResponseValidateE911.data });
      yield put({ type: Constants.E911_RESPONSE, response: true });
      hideLoader();
    } else {
      if (apiResponseValidateE911 && apiResponseValidateE911.data && apiResponseValidateE911.data.errors) {
        if (apiResponseValidateE911?.status === 400 && checkInvalidCaseCartError(apiResponseValidateE911.data.errors)) {
          invalidErrorCase = true;
          yield put({
            type: Constants.CEF_ADDONS_API_ERROR,
            errorDetails: invalidErrorCase,
            errorMessage: apiResponseValidateE911?.data?.errors[0]?.notifyMessage,
          });
        } else {
          errorDetails = true;
          yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponseValidateE911?.data?.errors[0]?.notifyMessage });
        }
        if (apiResponseValidateE911.data.loggerData)
          apiResponseValidateE911.data.loggerData.note = `validatee911Call ${apiResponseValidateE911?.data?.loggerData.note}`;
        logger(apiResponseValidateE911?.data?.loggerData);
        hideLoader();
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
      // logError('validatee911Call', apiResponse?.data?.errors, FE_API_ERROR);
    }
  } catch (errorValidateE911) {
    if (errorValidateE911 && errorValidateE911.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      hideLoader();
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('validatee911Call', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* updateProcessStepAddons(data) {
  let errorDetails = false;
  let invalidErrorCase = false;
  yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
  yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
  yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: null });
  const pageName = data?.pageName || '';
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponseProcessStep = yield call(addonActions.updateProcessStepApi, data, pageName);
    if (apiResponseProcessStep && apiResponseProcessStep.data && !apiResponseProcessStep.data.errors) {
      if (enablePegaProcessSteps() && apiResponseProcessStep?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep) {
        const processStep = GetProcessStepPages(apiResponseProcessStep?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep);
        if (processStep && processStep !== '') {
          yield put({ type: 'NEXT_PROCESS_STEP', value: processStep });
        }
        const currentPageName = GetCurrentPageName();
        if (currentPageName) {
          yield put({ type: 'PREVIOUS_PROCESS_STEP', value: currentPageName });
        }
        yield put({ type: 'UPDATED_ADDONS_PROCESSSTEP', value: true });
      }
    } else if (apiResponseProcessStep && apiResponseProcessStep?.data && apiResponseProcessStep?.data?.errors) {
      if (apiResponseProcessStep?.status === 400 && checkInvalidCaseCartError(apiResponseProcessStep.data.errors)) {
        invalidErrorCase = true;
        yield put({
          type: Constants.CEF_ADDONS_API_ERROR,
          errorDetails: invalidErrorCase,
          errorMessage: apiResponseProcessStep?.data?.errors[0]?.notifyMessage,
        });
      } else {
        errorDetails = true;
        yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: apiResponseProcessStep?.data?.errors[0]?.notifyMessage });
      }

      if (apiResponseProcessStep?.data?.loggerData) {
        apiResponseProcessStep.data.loggerData.note = `updateProcessStepAddons ${apiResponseProcessStep.data.loggerData.note}`;
        logger(apiResponseProcessStep.data.loggerData);
      }
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
      yield put({ type: Constants.ADDON_INVALIDCASE_ERROR, response: invalidErrorCase });
      hideLoader();
    }
  } catch (error) {
    // logError('updateProcessStepAddons', error, FE_API_JS_ERROR);
    if (error && error.message) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_ADDON_API_ERROR, errorDetails });
    }
    yield put({ type: Constants.CEF_ADDONS_API_ERROR, errorDetails, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_ADDONS, getAddons);
  yield takeLatest('VISION_PENDING', visionPending);
  // yield takeLatest(Constants.GET_ADDONS_AEM, getAddonsAEM);
  yield takeLatest(Constants.FETCH_E911ADDRESS, fetchE911Address);
  yield takeLatest(Constants.GET_NPA_NXX, getNPANXX);
  yield takeLatest(Constants.ADD_YTTV_TO_CART, addYTTVtoCart);
  yield takeLatest(Constants.GET_PROMOS, getPromos);
  yield takeLatest(Constants.GET_NPA_NXX_ON_HP, getNpanxxCall);
  yield takeLatest(Constants.GET_ASSIGNMTN, callAssignMtnApi);
  yield takeLatest(Constants.NPA_CALL, isNpaCall);
  yield takeLatest(Constants.HOME_LINE_CALL, homeLineCall);
  yield takeLatest(Constants.UPDATE_MTN_STATUS, updateMTNStatus);
  yield takeLatest(Constants.SKIP_STATUS, isSkip);
  yield takeLatest(Constants.SET_ADDONS, setAddons);
  yield takeLatest(Constants.VALIDATE_E911, validatee911Call);
  yield takeLatest(Constants.UPDATE_PROCESS_STEP_ADDONS, updateProcessStepAddons);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
